export interface OnboardingSEMWorkflow {
    Code?: string,
    Libelle?: string,
    Order?: number
}

const IDENTIFICATION_SEM: string = "IDS"
const VERIFICATION: string = "VER"
const ADRESSES: string = "ADD"
const PIECE_JUSTIFICATIVE: string = "PJS"
const COLLABORATEURS: string = "COL"
const BENEFICIAIRES_EFFECTIFS = "BNE"
const COMPLET: string = "CPL"

export const OnboardingSEMWorkflow = {
    IDENTIFICATION_SEM,
    VERIFICATION,
    ADRESSES,
    PIECE_JUSTIFICATIVE,
    COLLABORATEURS,
    BENEFICIAIRES_EFFECTIFS,
    COMPLET
}